import axios, { AxiosHeaders, InternalAxiosRequestConfig } from 'axios'
import { getToken } from 'core/auth'
import type { StandardErrorResponse } from 'types/APIResponses'

const CLIENT_APP_HEADER_NAME = 'X-Client-App'
const CLIENT_APP_NAME = 'Support-Tool'

export const phiApi = axios.create()

phiApi.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const headers = AxiosHeaders.from(config.headers)

  headers.set(CLIENT_APP_HEADER_NAME, CLIENT_APP_NAME)
  headers.set('Authorization', `Bearer ${getToken()}`)
  config.headers = headers
  config.baseURL = `${window.env('PHI_URL')}/v1`
  return config
})

phiApi.interceptors.response.use(
  (response) => response,
  (error): Promise<StandardErrorResponse> => {
    const method = error?.config?.method?.toUpperCase()
    const isPut = method === 'PUT'

    const defaultPutMessage = 'Unable to update PHI data. Please try again later.'
    const defaultMessage = 'Error in request to patient data service'

    if (!error?.response) {
      const standardError: StandardErrorResponse = {
        response: {
          data: {
            error: isPut ? defaultPutMessage : defaultMessage,
          },
        },
      }

      return Promise.reject(standardError)
    }

    const standardError: StandardErrorResponse = {
      response: {
        data: {
          error:
            error?.response?.data?.error ??
            error?.response?.data?.message ??
            error?.message ??
            (isPut ? defaultPutMessage : defaultMessage),
        },
      },
    }

    return Promise.reject(standardError)
  },
)
